/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import { ConfigProvider, Layout } from 'antd';
import { IntlProvider } from 'react-intl';
import { getAdminWebsite } from 'utils';
import { useNavigatorOnLine } from 'utils/hooks';
import AppLocale from '../../locales';

const AuthLayout = ({ children, setAdmin, locale, userToken, userData }) => {
    const currentLocale = AppLocale[locale];
    const isOperatorWithoutMachine = userData.data?.user_group[0].name === 'operator' && userData.operator?.machine === null;

    useNavigatorOnLine(locale);

    useEffect(() => {
        setAdmin(getAdminWebsite());

        if (userToken.data !== null) {
            if (!isOperatorWithoutMachine) {
                window.location = '/dashboard';
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (userToken.data !== null && !isOperatorWithoutMachine) {
        return null;
    }

    return (
        <ConfigProvider locale={currentLocale.antd}>
            <IntlProvider locale={currentLocale.locale} messages={currentLocale.messages}>
                <Layout className="gx-app-layout gx-p-0">
                    <Layout.Content className="gx-container-wrap gx-main-content-wrapper">
                        {children}
                    </Layout.Content>
                </Layout>
            </IntlProvider>
        </ConfigProvider>
    );
};

export default AuthLayout;
